
  var _styles = {
  "city-list-letter": {
    "fontWeight": "500",
    "fontFamily": "PingFangSC-Medium",
    "fontSize": "0.37333rem",
    "color": "rgb(32,32,32)",
    "letterSpacing": 0,
    "lineHeight": "0.4rem",
    "marginTop": "0.45333rem",
    "marginRight": 0,
    "marginBottom": "0.18667rem",
    "marginLeft": "0.53333rem"
  },
  "city-list-divider-container": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center",
    "justifyContent": "center"
  },
  "city-list-short-divider": {
    "height": "1px",
    "backgroundColor": "rgb(244,245,248)",
    "width": "8.66667rem"
  },
  "city-list-city-name": {
    "fontWeight": "400",
    "fontFamily": "PingFangSC-Regular",
    "fontSize": "0.37333rem",
    "color": "rgb(34,34,34)",
    "letterSpacing": 0,
    "lineHeight": "0.53333rem",
    "marginTop": "0.30667rem",
    "marginRight": 0,
    "marginBottom": "0.30667rem",
    "marginLeft": "0.53333rem"
  }
};



  module.exports = _styles;
  